import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { AppMaterialModule } from '../../app-material/app-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ToolbarComponent } from './toolbar.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    CommonModule,
    AppMaterialModule,
    HttpClientModule,
    TranslateModule,
    FlexLayoutModule
  ],
  declarations: [
    ToolbarComponent
  ],
  exports: [ToolbarComponent],
  bootstrap: [ToolbarComponent]
})
export class ToolbarModule { }